import Vue from 'vue'
import FilterBusinessLine from './common/FilterBusinessLine.vue'
import FilterPartner from './common/FilterPartner.vue'
import FilterRegion from './common/FilterRegion.vue'
import FilterBusinesslineRegion from './common/FilterBusinesslineRegion.vue'
import FilterBusinesslinePartner from './common/FilterBusinesslinePartner.vue'
import FilterRegionNation from './common/FilterRegionNation.vue'
import FilterJobType from './common/FilterJobType.vue'
import FilterWorkerType from './common/FilterWorkerType.vue'
import FilterChargeType from './common/FilterChargeType.vue'
import FilterDateRange from './common/FilterDateRange.vue'
import FilterAccountStatus from './common/FilterAccountStatus.vue'
import FilterBikeType from './common/FilterBikeType.vue'
import FilterRiskType from './common/FilterRiskType.vue'
import CommonReportTable from './common/common-report-table.vue'
import BikeTableDialog from './BikeTableDialog/index.vue'

const components = [
  FilterBusinessLine,
  FilterPartner,
  FilterRegion,
  FilterBusinesslineRegion,
  FilterBusinesslinePartner,
  FilterRegionNation,
  FilterJobType,
  FilterWorkerType,
  FilterChargeType,
  FilterDateRange,
  FilterAccountStatus,
  FilterBikeType,
  FilterRiskType,
  CommonReportTable,
  BikeTableDialog,
]
components.forEach(el => {
  Vue.component(el.name, el)
})
